import { useQuery } from "@tanstack/react-query";
import { getSpaceHubOptions, type SpaceHubResponse } from "@/api";

/**
 * While a workflow card shows a run in progress, check again this often so it moves on when the run does. Not in
 * background tabs (TanStack pauses intervals there): every tab counts toward the rate limit.
 */
const RUNNING_POLL_MS = 10_000;
const IN_PROGRESS = new Set(["pending", "running"]);

const hasRunningWorkflow = (hub: SpaceHubResponse | undefined) =>
  [...(hub?.resources ?? []).map((r) => r.flow), ...(hub?.unplacedWorkflows ?? [])].some((w) =>
    IN_PROGRESS.has(w?.lastRunStatus ?? ""),
  );

/** The space page's data (one request). Every section reads from this query. */
export function useSpaceHub(spaceUuid: string, enabled = true) {
  return useQuery({
    ...getSpaceHubOptions({ path: { space_uuid: spaceUuid } }),
    select: (r) => r.data,
    enabled: enabled && Boolean(spaceUuid),
    refetchInterval: (q) => (hasRunningWorkflow(q.state.data?.data) ? RUNNING_POLL_MS : false),
  });
}
